import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
const QA_53 = 99535353;
const PROD_53 = 53;
export const useIsBETPortal = () => PortalIdParser.get() === (enviro.isQa() ? QA_53 : PROD_53);